import { useLocation, useParams } from "react-router-dom";
import { M2MPaymentVerificationView } from "./slices/m2m-payment-verification";
import { Redirect } from "common/Redirect";
import { LeaseEndingIssueView } from "./slices/lease-end-flow";
import { useMemo } from "react";

import { logger } from "logger";

export const RentReportingIssuesM2MLeaseEndView = () => {
  const { state } = useLocation();
  // issue from params
  const { issue: paramsIssue } = useParams();

  const issue = useMemo(() => {
    try {
      return (
        JSON.parse(state?.issue || "") ||
        JSON.parse(decodeURIComponent(paramsIssue || ""))
      );
    } catch (error) {
      logger.error("Failed to parse issue", { error, state, paramsIssue });
      return null;
    }
  }, [state, paramsIssue]);

  if (!issue) return <Redirect href="/hub?with_intercom=true" />;

  if (issue?.slug === "m2m-payment-verification")
    return <M2MPaymentVerificationView issue={issue} />;

  if (issue?.slug === "lease_end_close_verification")
    return <LeaseEndingIssueView />;

  return <Redirect href="/hub?with_intercom=true" />;
};
